import React, { useRef, useState, useEffect } from 'react';
import Button from 'antd/lib/button';
import Modal from 'antd/lib/modal';
import { Radio, Select } from 'antd';
import 'antd/lib/button/style/index';
import 'antd/lib/menu/style/index';
import 'antd/lib/dropdown/style/index';
import 'antd/lib/avatar/style/index';
import 'antd/lib/tabs/style/index';
import 'antd/lib/page-header/style/index';
import 'antd/lib/modal/style/index';
import 'antd/lib/pagination/style/index';
import 'antd/lib/empty/style/index';
import Loader from 'pages/Test/localComponent/loader';
import { Api, Utils } from 'services';

const { Option } = Select;

function RecordingModal ({visible, onCancel, onConfirm, title, content, confirmTitle="YES", rejectTitle="CANCEL", onClose=null, loading=false, fullmodalloading=false
, getVideoResourceSections, selectedSchedule,
sectionList, selectedSection, setSelectedSection, isRecording, recordCount, localRecordingCount,
recordingBatches, setRecordingBatches, postCreateTopic}) {
    const [value, setValue] = useState(true);
    const [input, setInput] = useState('');
    const [topicName, setTopicName] = useState(null);
    const [filteredSelectionList, setFilteredSelectionList] = useState([]);
    const hasInputField = isRecording===0 && (value?localRecordingCount===0:recordCount===0)
    const classRef = useRef(null);

    // Same shape passiveCanvas.js already derives from activeClass.occurance for the
    // digital-library image upload — subjectId/standardId aren't flat fields on the
    // occurrence, they live under subject/standards. A single Broadcast class can be
    // taught to more than one batch at once, but it's still one live lesson — whatever
    // chapter/topic is being taught is the same for every batch watching it. So this
    // only tracks ONE shared chapter/topic, applied to every batch, rather than letting
    // each batch carry its own (that would imply different content per batch, which
    // isn't true for a single recorded session).
    const subjectId = selectedSchedule?.subject?.id || selectedSchedule?.subjectId || null;
    const standards = (selectedSchedule?.standards || [])
      .map(s => ({
        id: s.stdId || s.id,
        label: (s.std && s.section) ? `${s.std}-${s.section}` : (s.std || s.section || '')
      }))
      .filter(s => s.id);
    const primaryStandardId = standards[0]?.id || null;

    const [recChapters, setRecChapters] = useState([]);
    const [recChaptersLoading, setRecChaptersLoading] = useState(false);
    const [recChapterId, setRecChapterId] = useState(null);
    const [recChapterName, setRecChapterName] = useState('');
    const [recTopics, setRecTopics] = useState([]);
    const [recTopicsLoading, setRecTopicsLoading] = useState(false);
    const [recTopicId, setRecTopicId] = useState(null);
    const [recTopicName, setRecTopicName] = useState('');
    const [recTopicSearch, setRecTopicSearch] = useState(null);

    const fetchChapters = (name='') => {
        if (!primaryStandardId) return;
        setRecChaptersLoading(true);
        const url = `/admin-library/filterChapter?name=${name}&standardId=${primaryStandardId}&subjectId=${subjectId || ''}`;
        Api.get(url).send((response) => {
            setRecChapters(Array.isArray(response) ? response : []);
            setRecChaptersLoading(false);
        });
    };

    const fetchTopics = (chapterId, onLoaded) => {
        setRecTopicsLoading(true);
        const url = `/admin-library/filterTopic?subjectId=${subjectId || ''}&standardId=${primaryStandardId}&chapterId=${chapterId}`;
        Api.get(url).send((response) => {
            const topics = Array.isArray(response) ? response : [];
            setRecTopics(topics);
            setRecTopicsLoading(false);
            if (onLoaded) onLoaded(topics);
        });
    };

    useEffect(()=>{
    setSelectedSection({})
    setRecChapterId(null);
    setRecChapterName('');
    setRecTopicId(null);
    setRecTopicName('');
    setRecTopicSearch(null);
    setRecTopics([]);
    setRecChapters([]);
    if (selectedSchedule.videoResourceIds?.length){
        getVideoResourceSections(selectedSchedule.videoResourceIds, ()=>{})
    }
    if (subjectId && primaryStandardId){
        fetchChapters()
    }
    }, []);
    useEffect(()=>{
      setFilteredSelectionList(sectionList)
    }, [sectionList])

    // Keep the parent in sync with whatever's been picked so far, so it's ready to send
    // the moment Confirm is clicked (Confirm itself only forwards input/isOffline, not
    // this state). Every batch gets the SAME chapter/topic — it's one recording.
    useEffect(() => {
        setRecordingBatches(standards.map(s => ({
            standardId: s.id,
            chapterId: recChapterId,
            chapterName: recChapterName,
            topicId: recTopicId,
            topicName: recTopicName
        })));
    }, [recChapterId, recChapterName, recTopicId, recTopicName, selectedSchedule]);

    const handleChapterChange = (text, option) => {
      if (text===undefined){
        setRecChapterId(null); setRecChapterName(''); setRecTopicId(null); setRecTopicName(''); setRecTopicSearch(null); setRecTopics([]);
      }else{
        setRecChapterId(option.key); setRecChapterName(option.value); setRecTopicId(null); setRecTopicName(''); setRecTopicSearch(null); setRecTopics([]);
        fetchTopics(option.key);
      }
    };

    const handleTopicChange = (text, option) => {
      if (text===-1){
        const createdName = recTopicSearch?.trim();
        // postCreateTopic's first (`callback`) arg fires on BOTH success and failure —
        // only `successCallback` is success-only — so it can't be used to detect an
        // error here. The backend's own response already carries a `show` directive
        // that Api.js auto-displays as a snackbar (that's the generic "Topic created
        // successfully!" toast) on success, and Api.js does the same for real failures
        // that come back with a message, so no manual notification is needed for either.
        postCreateTopic({chapterId: recChapterId, topicName: createdName}, () => {}, () => {
          fetchTopics(recChapterId, (topics) => {
            const match = topics.find(item => (item.name || item.topicName) === createdName);
            setRecTopicId(match ? (match.id || match.topicId) : null);
            setRecTopicName(match ? (match.name || match.topicName) : createdName);
            setRecTopicSearch(null);
          });
        });
      }else if (text===undefined){
        setRecTopicId(null); setRecTopicName('');
      }else{
        setRecTopicId(option.key); setRecTopicName(option.value);
      }
    };

    const handleSearchTopic = (value) => {
      if (value && value.trim() != '') {
        setFilteredSelectionList(sectionList?.filter((item) => item.title.toLowerCase().includes(value.toLowerCase())))
        setTopicName(value)
      }
      else {
        setTopicName(null);
        setFilteredSelectionList(sectionList)
      }
    }
    const onChange = (e) => {
      setValue(e.target.value);
    };

    // A class recording has no chapter/topic of its own (same reasoning as
    // ResourceAddForm.js's isRecording flag for the Resources tab) — so this
    // modal shouldn't ask for them when recording an Online class either.
    const showChapterTopicFields = false;
    const allBatchesTagged = standards.length>0 && !!recChapterId && !!recTopicId;

    // fetchTopics always loads every topic under the chapter — it has no server-side
    // search param — so filter what's typed against that full list here instead.
    // Without this, "+ Create topic" only ever showed up when the chapter had zero
    // topics at all, never when the typed name just didn't match any of the existing
    // ones.
    const recTopicSearchText = (recTopicSearch || '').trim().toLowerCase();
    const filteredTopics = recTopicSearchText
      ? (recTopics || []).filter(item => (item.name || item.topicName || '').toLowerCase().includes(recTopicSearchText))
      : (recTopics || []);
    const showCreateTopicOption = !!recTopicSearchText && filteredTopics.length === 0;

    return (
      <Modal
        centered
        className='modal-round-corner'
        style={{padding:0}}
        visible={visible}
        onCancel={onClose?onClose:onCancel}
        onOk={onClose?onClose:onCancel}
        footer={null}
      >
        {
          fullmodalloading?
          <div style={{paddingTop:50, paddingBottom:50}}>
            <Loader style={{fontSize:50, color:"#5448b7"}}/>
          </div>
          :
            <>
              <div className='text-sm text-center bold-600 color-purple m-t-20'>
                  {title}
              </div>
              <div className='text-xs text-center a2grey m-b-20'>
                  {content}
              </div>
              <div style={{display:"flex", flexDirection:"column",alignItems:"center"}}>
                {
                  isRecording===0?
                  <div style={{display:"flex", flexDirection:"column", alignItems:"flex-start"}}>
                    <div className='bold-600' style={{ color: '#636363', marginBottom: 5, fontSize:12 }}>Mode of recording <span style={{color:"red"}}>*</span></div>
                    <Radio.Group onChange={onChange} value={value} style={{ marginTop: "5px", width:300 }}>
                        <Radio value={true}>Offline</Radio>
                        <Radio value={false}>Online</Radio>
                    </Radio.Group>
                  </div>
                  :null
                }
                {
                  hasInputField?
                      <div className='r-c-c m-t-15'>
                        <div style={{display:"flex", flexDirection:"column", alignItems:"flex-start"}}>
                            <div className='bold-600' style={{ color: '#636363', marginBottom: 5, fontSize:12 }}>Name <span style={{color:"red"}}>*</span></div>
                            <input value={input} onChange={(e)=>{
                              if (Utils.isValidString(e.target.value)||e.target.value?.trim()===''){
                                setInput(e.target.value)
                              }
                            }} onKeyDown={(e)=>{
                                  if(e.key === 'Enter') {
                                      const disabled = hasInputField && (input==undefined||input?.trim()==''||(!value && selectedSchedule.videoResourceIds?.length && (selectedSection==undefined || selectedSection.id==undefined)));
                                      if (!disabled) {
                                          console.log("50", input)
                                          onConfirm(input, value);
                                      }
                                  }
                            }} placeholder='Please enter a file name for the recording' style={{border:"none", borderBottomColor:"#5448b7", borderBottomWidth:1, borderBottomStyle:"solid", width:300}}></input>
                        </div>
                      </div>
                  :null
                }
              </div>
              {showChapterTopicFields?
                <div className='r-c-c-c m-t-15' style={{width:"100%"}}>
                  {standards.length>1 &&
                    <div className='text-xs text-center a2grey' style={{ width:300, marginBottom: 8 }}>
                      Applies to all {standards.length} batches: {standards.map(s => s.label || s.id).join(', ')}
                    </div>
                  }
                  <div style={{display:"flex",flexDirection:"column", alignItems:"flex-start", width:300, marginBottom:10}}>
                          <div className='bold-600' style={{ color: '#636363', marginBottom: 5, fontSize:12 }}>Chapter <span style={{color:"red"}}>*</span></div>
                          <Select
                              allowClear
                              size="middle"
                              showSearch
                              bordered={false}
                              className="test-custom-select createTestModalValue"
                              placeholder={"Select chapter"}
                              style={{width:"100%"}}
                              value={recChapterName || undefined}
                              loading={recChaptersLoading}
                              showArrow={true}
                              filterOption={false}
                              defaultActiveFirstOption={false}
                              notFoundContent={recChaptersLoading ? null : "No chapter found"}
                              onSearch={(text) => fetchChapters(text)}
                              onFocus={() => fetchChapters()}
                              onChange={handleChapterChange}
                          >
                              {
                                  recChapters?.map((item)=>{
                                      const id = item.id || item.chapterId || item.chapterid;
                                      const name = item.name || item.chapterName;
                                      return <Option key={id} className="createTestModalDropdown" value={name}>{name}</Option>
                                  })
                              }
                          </Select>
                   </div>
                  <div style={{display:"flex",flexDirection:"column", alignItems:"flex-start", width:300}}>
                          <div className='bold-600' style={{ color: '#636363', marginBottom: 5, fontSize:12 }}>Topic <span style={{color:"red"}}>*</span></div>
                          <Select
                              allowClear
                              size="middle"
                              showSearch
                              bordered={false}
                              disabled={!recChapterId}
                              className="test-custom-select createTestModalValue"
                              placeholder={"Select topic"}
                              style={{width:"100%"}}
                              value={recTopicName || undefined}
                              loading={recTopicsLoading}
                              showArrow={true}
                              filterOption={false}
                              defaultActiveFirstOption={false}
                              notFoundContent={recTopicsLoading ? null : "No topic found"}
                              onSearch={(text) => {
                                setRecTopicSearch(text && text.trim() !== '' ? text : null);
                              }}
                              onFocus={() => fetchTopics(recChapterId)}
                              onChange={handleTopicChange}
                              onInputKeyDown={(e) => {
                                // defaultActiveFirstOption is off, so the "+ Create topic"
                                // option never has keyboard focus for Enter to pick up on
                                // its own — trigger the same creation path onChange(-1)
                                // uses whenever Enter is pressed while it's the only option.
                                if (e.key === 'Enter' && showCreateTopicOption) {
                                  e.preventDefault();
                                  handleTopicChange(-1);
                                } else if (e.key === 'Backspace' && !recTopicSearchText && recTopicName) {
                                  // A topic is already selected and the search box is empty
                                  // (re-focusing a filled Select doesn't repopulate the box
                                  // with the old value) — so Backspace has nothing to delete
                                  // and looks like it does nothing. Treat it as "clear the
                                  // selection", same as clicking the allowClear "x".
                                  e.preventDefault();
                                  handleTopicChange(undefined);
                                }
                              }}
                          >
                              {
                                  filteredTopics.map((item)=>{
                                      const id = item.id || item.topicId;
                                      const name = item.name || item.topicName;
                                      return <Option key={id} className="createTestModalDropdown" value={name}>{name}</Option>
                                  })
                              }
                              {
                                showCreateTopicOption?
                              <Option key={'create'} className="createTestModalDropdown" value={-1}>{`+ Create topic ${recTopicSearch}`}</Option>
                              :null
                              }
                          </Select>
                   </div>
                 </div>
              :null}
              {hasInputField && selectedSchedule.videoResourceIds?.length && !value?
                    <div className='r-c-c m-t-15'>
                    <div style={{display:"flex",flexDirection:"column", alignItems:"flex-start", width:300}}>
                            <div className='bold-600' style={{ color: '#636363', marginBottom: 5, fontSize:12 }}>Section name  <span style={{color:"red"}}>*</span></div>
                            <Select
                                allowClear
                                disabled={false}
                                size="middle"
                                showSearch
                                bordered={false}
                                className="test-custom-select createTestModalValue"
                                placeholder={"Select section"}
                                loading={false}
                                style={{width:"100%"}}
                                value={selectedSection?.name}
                                showArrow={true}
                                filterOption={false}
                                defaultActiveFirstOption={false}
                                notFoundContent={null}
                                onSearch={handleSearchTopic}
                                // onSearch={(text) => { setSearchText(text); setSearchTextIndex('examiner'); updateHandleRender(true) }}
                                onChange={(text, value) => {
                                  console.log("109", text)
                                  if (text===-1){
                                    setSelectedSection({id: -1, name:topicName, title:topicName})
                                  }else if (text==undefined){
                                    setSelectedSection({})
                                  }else{
                                    setSelectedSection({id: value.key, name:value.value, title:value.value})
                                  }
                                 }}
                            >
                                {
                                    filteredSelectionList?.filter((item)=>item.id!=selectedSection?.id).map((item)=>{
                                        return <Option key={item?.id} className="createTestModalDropdown" value={item.title}>{item.title}</Option>
                                    })
                                }
                                {
                                  filteredSelectionList?.length===0 && topicName?
                                <Option key={'create'} className="createTestModalDropdown" value={-1}>{`+ Create section ${topicName}`}</Option>
                                :null
                                }
                            </Select>
                     </div>
                     </div>
                :null}
              <div className='r-c-c m-t-30'>
                <Button className='blankGreyBtnWrap radius-100' onClick={onCancel}>{rejectTitle}</Button>
                <Button className={"radius-100 m-l-20 purpleBtnWrap purpleButtonHoverEffect"} onClick={()=>{onConfirm(input, value)}} loading={loading} disabled={hasInputField && (input==undefined||input?.trim()==''||(!value && selectedSchedule.videoResourceIds?.length && (selectedSection==undefined || selectedSection.id==undefined)))}>{confirmTitle}</Button>
              </div>
            </>
        }
      </Modal>
  );
}



export default RecordingModal;
